import ContactForm from '../../components/ContactForm';
import Layout from '../../components/Layout';
import SectionHeading from '../../components/SectionHeading';
import { useSiteContent } from '../../content/ContentContext';

export default function ContactPage() {
  const {
    content: { site },
  } = useSiteContent();

  return (
    <Layout>
      <section className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:px-8 lg:py-24">
        <div>
          <SectionHeading eyebrow="Contact" title={site.contactTitle} description={site.contactDescription} />
          <div className="space-y-5 rounded-[2rem] bg-[#123018] p-8 text-white shadow-xl">
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#7dff45]">Phone</p>
              <a href={site.phoneHref} className="mt-2 block text-2xl font-black">{site.phoneDisplay}</a>
            </div>
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#7dff45]">Email</p>
              <a href={`mailto:${site.email}`} className="mt-2 block break-all text-lg font-semibold">{site.email}</a>
            </div>
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#7dff45]">Service Area</p>
              <p className="mt-2 text-lg font-semibold">{site.serviceArea}</p>
            </div>
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#7dff45]">Property Types</p>
              <p className="mt-2 text-lg font-semibold">{site.propertyTypes}</p>
            </div>
          </div>
        </div>
        <ContactForm />
      </section>
    </Layout>
  );
}
